import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { Components, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

export const muiSelectOverride: Components<Omit<Theme, 'components'>>['MuiSelect'] = {
  defaultProps: {
    classes: {
      root: 'bg-white-100',
      disabled: 'text-text-60'
    },
    slotProps: {
      root: {
        sx: {
          '& .MuiInputLabel-root': {
            fontSize: '0.875rem'
          }
        }
      },
      input: {
        sx: {
          fontSize: '0.875rem'
        }
      }
    }
  },
  styleOverrides: {
    root: {
      // height: fieldHeight,
      fontSize: '0.875rem',
      [`:not(.${outlinedInputClasses.disabled})&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: colors.primary[80]
      },
      [`.${outlinedInputClasses.notchedOutline}`]: {
        borderColor: colors.text[80]
      }
    },
    select: {
      '&.Mui-disabled ~ .MuiInputLabel-root, &.Mui-disabled .MuiInputLabel-root': {
        color: colors.text[60]
      }
    }
  }
};
